import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum FrequencyDisciplineEnum {
    SkilledNurse = 1,
    HospicePhysician = 4,
    MedicalSocialWorker = 8,
    SpiritualCounselor = 16,
    BereavementCounselor = 32,
    VolunteerCoordinator = 64,
    PhysicalTherapist = 128,
    OccupationalTherapist = 256,
    SpeechTherapist = 512,
    MusicTherapist = 2048,
    ArtTherapist = 4096,
    MassageTherapist = 8192,
    AromaTherapist = 16384,
    HealingTouch = 32768,
    Hypnotherapist = 65536,
    PetTherapist = 131072,
    DietaryCounselor = 262144,
    Volunteer = 524288,
    HospiceAide = 1048576,
    PhysiciansAssistant = 16777216,
    HomeMaker = 33554432,
    NursePractitioner = 67108864
}

class FrequencyDisciplineClass extends EnumWithDescription<FrequencyDisciplineEnum> {
    public readonly enum = FrequencyDisciplineEnum;
    public readonly enumName: string = "FrequencyDisciplineEnumm";

    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<FrequencyDisciplineEnum>> = new Map([
        [
            "SkilledNurse",
            {
                name: "Skilled Nurse",
                value: FrequencyDisciplineEnum.SkilledNurse
            }
        ],
        [
            "HospicePhysician",
            {
                name: "Hospice Physician",
                value: FrequencyDisciplineEnum.HospicePhysician
            }
        ],
        [
            "MedicalSocialWorker",
            {
                name: "Medical Social Worker",
                value: FrequencyDisciplineEnum.MedicalSocialWorker
            }
        ],
        [
            "SpiritualCounselor",
            {
                name: "Spiritual Counselor",
                value: FrequencyDisciplineEnum.SpiritualCounselor
            }
        ],
        [
            "BereavementCounselor",
            {
                name: "Bereavement Counselor",
                value: FrequencyDisciplineEnum.BereavementCounselor
            }
        ],
        [
            "VolunteerCoordinator",
            {
                name: "Volunteer Coordinator",
                value: FrequencyDisciplineEnum.VolunteerCoordinator
            }
        ],
        [
            "PhysicalTherapist",
            {
                name: "Physical Therapist",
                value: FrequencyDisciplineEnum.PhysicalTherapist
            }
        ],
        [
            "OccupationalTherapist",
            {
                name: "Occupational Therapist",
                value: FrequencyDisciplineEnum.OccupationalTherapist
            }
        ],
        [
            "SpeechTherapist",
            {
                name: "Speech Therapist",
                value: FrequencyDisciplineEnum.SpeechTherapist
            }
        ],
        [
            "MusicTherapist",
            {
                name: "Music Therapist",
                value: FrequencyDisciplineEnum.MusicTherapist
            }
        ],
        [
            "ArtTherapist",
            {
                name: "Art Therapist",
                value: FrequencyDisciplineEnum.ArtTherapist
            }
        ],
        [
            "MassageTherapist",
            {
                name: "Massage Therapist",
                value: FrequencyDisciplineEnum.MassageTherapist
            }
        ],
        [
            "AromaTherapist",
            {
                name: "Aroma Therapist",
                value: FrequencyDisciplineEnum.AromaTherapist
            }
        ],
        [
            "HealingTouch",
            {
                name: "Healing Touch",
                value: FrequencyDisciplineEnum.HealingTouch
            }
        ],
        [
            "Hypnotherapist",
            {
                name: "Hypnotherapist",
                value: FrequencyDisciplineEnum.Hypnotherapist
            }
        ],
        [
            "PetTherapist",
            {
                name: "Pet Therapist",
                value: FrequencyDisciplineEnum.PetTherapist
            }
        ],
        [
            "DietaryCounselor",
            {
                name: "Dietary Counselor",
                value: FrequencyDisciplineEnum.DietaryCounselor
            }
        ],
        [
            "Volunteer",
            {
                name: "Volunteer",
                value: FrequencyDisciplineEnum.Volunteer
            }
        ],
        [
            "HospiceAide",
            {
                name: "Hospice Aide",
                value: FrequencyDisciplineEnum.HospiceAide
            }
        ],
        [
            "PhysiciansAssistant",
            {
                name: "Physician’s Assistant",
                value: FrequencyDisciplineEnum.PhysiciansAssistant
            }
        ],
        [
            "HomeMaker",
            {
                name: "Home Maker",
                value: FrequencyDisciplineEnum.HomeMaker
            }
        ],
        [
            "NursePractitioner",
            {
                name: "Nurse Practitioner",
                value: FrequencyDisciplineEnum.NursePractitioner
            }
        ]
    ]);
}

export const FrequencyDiscipline = new FrequencyDisciplineClass();
